import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SafeHtmlPipe } from '@web/common';

@Component({
  selector: 'app-public-html-content',
  imports: [SafeHtmlPipe],
  templateUrl: './public-html-content.component.html',
  styleUrl: './public-html-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicHtmlContentComponent {
  public readonly html = input.required<string>();
}
